import styled, { css } from 'styled-components';

export const Anchor = styled.a`
  ${({ theme, ...props }) => {
    return css`
      width: 3rem;
      height: 3rem;
      border: 1px solid ${theme.color.secondary_500};
      border-radius: ${theme.radius.full};
      display: flex;
      align-items: center;
      justify-content: center;

      &.mobile {
        @media screen and (min-width: ${theme.breakpoint.sm}) {
          display: none;
        }
      }
      &.desktop {
        display: none;
        @media screen and (min-width: ${theme.breakpoint.sm}) {
          display: flex;
        }
      }
    `;
  }};
`;
